module.exports = __webpack_public_path__ + "static/media/closeNotification.2ee3a2a7.svg";